// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteConfiguration, getAllConfigurations, getConfiguration, updateConfiguration, duplicateConfiguration, checkConfiguration, verifyConfiguration, checkExpiredConfig } from '../../helpers/backend_helper';
import { checkConfigurationFailure, checkConfigurationsExpiredFailure, checkConfigurationsExpiredSuccess, checkConfigurationSuccess, fetchConfigurationsFailure, fetchConfigurationsSuccess, openEditPageConfigurationSuccess, updateConfigurationFailure, updateConfigurationSuccess, verifyConfigurationFailure, verifyConfigurationSuccess } from './actions';
import { deleteConfigurationFailure, deleteConfigurationSuccess, fetchConfigurationFailure, fetchConfigurationSuccess, duplicateConfigurationSuccess, duplicateConfigurationFailure } from '../actions';
import { DELETE_CONFIGURATIONS_REQUEST, FETCH_CONFIGURATIONS_REQUEST, FETCH_CONFIGURATION_REQUEST, UPDATE_CONFIGURATIONS_REQUEST, DUPLICATE_CONFIGURATIONS_REQUEST, OPEN_EDIT_PAGE_CONFIGURATION, CHECK_CONFIGURATION_REQUEST, VERIFY_CONFIGURATION_REQUEST, CHECK_CONFIGURATIONS_EXPIRED_REQUEST} from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchConfigurationsSaga() {
  try {
    const response = yield call(getAllConfigurations);

    // Store the mapping in localStorage
    yield put(fetchConfigurationsSuccess(response.data));
  } catch (error) {
    console.log(error);

    yield put(fetchConfigurationsFailure(reduxSerializedError(error)));
  }
}

function* fetchConfigurationSaga({ payload }) {
  try {
    const response = yield call(getConfiguration, payload);
    yield put(fetchConfigurationSuccess(response));
  } catch (error) {
    console.log(error);

    yield put(fetchConfigurationFailure(reduxSerializedError(error)));
  }
}

function* deleteConfigurationsSaga({ payload }) {
  try {
    yield call(deleteConfiguration, payload);
    yield put(deleteConfigurationSuccess(payload));
    yield call(fetchConfigurationsSaga);
  } catch (error) {
    console.log(error);
    yield put(deleteConfigurationFailure(reduxSerializedError(error)));
  }
}

function* duplicateConfigurationsSaga({ payload }) {
  const { id, configDuplicate } = payload;
  try {
    yield call(duplicateConfiguration, id, configDuplicate);
    yield put(duplicateConfigurationSuccess());
    yield call(fetchConfigurationsSaga);
  } catch (error) {
    console.log(error);

    yield put(duplicateConfigurationFailure(reduxSerializedError(error)));
  }
}

function* updateConfigurationSaga({ payload }) {
  const { configuration, navigate, toConfig } = payload;
  try {
    const response = yield call(updateConfiguration, configuration);
    yield put(updateConfigurationSuccess());
    yield call(fetchConfigurationsSaga); 
    if (toConfig) {
      navigate(`/configurations/configurator/${response.data.id}`);
    } else {
      navigate(`/configurations`);
    }
  } catch (error) {
    console.log(error);

    yield put(updateConfigurationFailure(reduxSerializedError(error)));
  }
}

function* openEditPageConfigurationSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/configurations/${id}`);
    yield put(openEditPageConfigurationSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}

function* checkConfigurationSaga({ payload }) {
  const config = payload;
  try {
    const response = yield call(checkConfiguration, config.id, config);
    if (response) {
      yield put(checkConfigurationSuccess(response));
    }
  } catch (error) {

    yield put(checkConfigurationFailure(reduxSerializedError(error)));
  }
}

function* verifyConfigurationSaga({ payload }) {
  const config = payload;

  try {
    const response = yield call(verifyConfiguration, config.id, config);
    if (response) {
      yield put(verifyConfigurationSuccess(response));
    }
  } catch (error) {

    yield put(verifyConfigurationFailure(reduxSerializedError(error)));
  }
}

function* checkExpiredConfigurations({ payload }) {
  const days = payload;

  try {
    const response = yield call(checkExpiredConfig, days);
    if (response) {
      yield put(checkConfigurationsExpiredSuccess(response));
    }
  } catch (error) {

    yield put(checkConfigurationsExpiredFailure(reduxSerializedError(error)));
  }
}



export default function* rootSaga() {
  yield takeEvery(FETCH_CONFIGURATIONS_REQUEST, fetchConfigurationsSaga);
  yield takeEvery(FETCH_CONFIGURATION_REQUEST, fetchConfigurationSaga);
  yield takeEvery(UPDATE_CONFIGURATIONS_REQUEST, updateConfigurationSaga);
  yield takeEvery(DELETE_CONFIGURATIONS_REQUEST, deleteConfigurationsSaga);
  yield takeEvery(DUPLICATE_CONFIGURATIONS_REQUEST, duplicateConfigurationsSaga);
  yield takeEvery(OPEN_EDIT_PAGE_CONFIGURATION, openEditPageConfigurationSaga);
  yield takeEvery(CHECK_CONFIGURATION_REQUEST, checkConfigurationSaga);
  yield takeEvery(VERIFY_CONFIGURATION_REQUEST, verifyConfigurationSaga);
  yield takeEvery(CHECK_CONFIGURATIONS_EXPIRED_REQUEST, checkExpiredConfigurations);
}
